/* ---------------------------------------------------------------------------
 * leotude-video-peek.js  —  v1.0
 *
 * On a phone, show the first image for a moment, then slide the gallery
 * across to the video on its own.
 *
 * The reasoning behind the order: the first image is the one that has to
 * survive a shopper who never scrolls, so it stays first and stays still.
 * The video then arrives as movement in a frame the eye is already resting
 * on, which is the part that holds attention. Putting the video first would
 * trade a guaranteed good first frame for an autoplay that any phone is free
 * to refuse.
 *
 * Desktop is left alone. There the gallery is a grid or a stacked column,
 * every media item is already on screen, and there is nothing to advance to.
 * The slider only exists below Dawn's 750px breakpoint.
 *
 * How the move is made: the slide list is scrolled horizontally, the same
 * thing a swipe does. media-gallery exposes setActiveMedia(), which would be
 * the obvious choice, but it ends in scrollIntoView() on the slide — and on a
 * phone that scrolls the page vertically as well, yanking the header out of
 * view two seconds after the shopper lands. Scrolling the list itself moves
 * nothing but the gallery, and slider-component picks up the scroll event and
 * updates its own dots and counter from it, so nothing is left out of sync.
 *
 * The shopper wins any tie. A touch, a swipe or a thumbnail tap inside the
 * gallery before the timer fires cancels it for good: someone who has started
 * looking on their own should not have the slide pulled out from under them.
 * It also fires only once per page load, and only while the gallery is still
 * on screen — if they have already scrolled down to the description, moving
 * the gallery behind them is pointless motion.
 * ------------------------------------------------------------------------- */
(function () {
  'use strict';

  /* Two seconds: long enough to read the first image as a photograph rather
     than a flash, short enough to land before a shopper starts scrolling. */
  var DELAY = 2000;

  /* Dawn's own mobile breakpoint. Above it the media is a grid, not a
     slider, and there is nothing here to do. */
  var MOBILE_MAX = 749;

  var done = false;
  var cancelled = false;
  var timer = null;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function onScreen(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight;
  }

  function cancel() {
    cancelled = true;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function run() {
    if (done || cancelled || !isMobile()) return;

    var slider = document.querySelector('.product__media-list');
    if (!slider) return;

    /* The video slide is found by looking for the container class the
       snippet writes, not by assuming a position. Media order is edited in
       the Shopify admin and will change; a hardcoded index would break the
       first time someone reorders the images. */
    var videoItem = slider.querySelector('.product-media-container.media-type-video');
    if (!videoItem) return;

    var slide = videoItem.closest('.product__media-item, .slider__slide, li');
    if (!slide) return;

    /* Already sitting on it — the video is the first media, or the shopper
       moved there in the gap between load and timer. Nothing to do. */
    if (Math.abs(slide.offsetLeft - slider.scrollLeft) < 10) {
      done = true;
      return;
    }

    if (!onScreen(slider)) return;

    done = true;
    slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
  }

  function boot() {
    if (!isMobile()) return;

    var slider = document.querySelector('.product__media-list');
    if (!slider) return;

    /* Any deliberate move inside the gallery takes precedence. touchstart
       rather than scroll, because the smooth scroll above fires scroll
       events of its own and would otherwise cancel itself. */
    ['touchstart', 'pointerdown', 'click'].forEach(function (evt) {
      slider.addEventListener(evt, cancel, { passive: true, once: true });
    });

    var thumbs = document.querySelector('.thumbnail-list');
    if (thumbs) {
      thumbs.addEventListener('click', cancel, { passive: true, once: true });
    }

    timer = setTimeout(run, DELAY);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();